import React from "react";
import LegalContentPage from "./legal_content_page";
import type { ContentItem } from "./legal_content_page";

const privacyPolicyText: ContentItem[] = [
  {
    type: "heading",
    text: "Last Updated April 14, 2024",
  },
  {
    type: "paragraph",
    text: "We're finalizing our Privacy Policy. The full policy will be published here shortly — please check back soon.",
  },
];
const PrivacyPolicyPage: React.FC = () => {
  return (
    <LegalContentPage title="Privacy Policy" content={privacyPolicyText} />
  );
};

export default PrivacyPolicyPage;
